import { useMemo } from 'react';

import { useGrid } from '@Components/Grid/context';

import DefaultTableBody from './Body';
import DefaultTableHeader from './Header';
import TableWrapper from './Wrapper';
import { TableProvider } from './context';

export default function DefaultTable() {
  const {
    columns = [],
    rowsSelected = [],
    setRowsSelected,
    store: {
      loading,
      collections: { items = [] },
    },
  } = useGrid()

  const bodyColumns = useMemo(() => columns.map((column, index) => ({
    id: column.id || `column-${index}`,
    dataField: column.accessorKey || column.id,
    className: column.columnClassName || column.cellClassName || column.className || column.meta?.className,
    formatter: column.cell,
  })), [columns])

  return <TableProvider>
    <TableWrapper>
      <DefaultTableHeader />
      <DefaultTableBody
        rows={items}
        columns={bodyColumns}
        loading={loading}
        rowsSelected={rowsSelected}
        setRowsSelected={setRowsSelected}
      />
    </TableWrapper>
  </TableProvider>
}
